module.exports = __webpack_public_path__ + "static/media/punto_mujer.62393437.png";